{
  "app_augi_sable_chassis_3d": {
    "name": "Sable Studio",
    "purpose": "Compare three chassis designs in 3D as you adjust wheelbase, width, and wall thickness."
  },
  "app_rm_variance_workbench": {
    "name": "Rookmere Close",
    "purpose": "Map monthly trial balances to track EBITDA, currency changes, and debt covenant headroom."
  },
  "app_augi_bom_mass_ledger": {
    "name": "Sable Balance",
    "purpose": "Move and weigh vehicle parts in a 3D X-ray view to check axle load and center of gravity."
  },
  "app_augi_fastener_weld_matrix": {
    "name": "Joining Registry",
    "purpose": "Look up approved rivet sizes, alloy limits, and adhesive thickness for body joints."
  },
  "app_augi_pack_thermal_clearance": {
    "name": "Pack Clearance",
    "purpose": "Check 2D spacing tolerances between battery modules, cooling plates, and lower shields."
  },
  "app_rm_diligence_tracker": {
    "name": "Diligence Tracker",
    "purpose": "Combine duplicate diligence questions from spreadsheets and assign an owner to each item."
  },
  "app_rm_valuation_bridge": {
    "name": "Valuation Bridge",
    "purpose": "Break down quarterly company value changes across earnings, debt paydown, and currency."
  },
  "app_rm_expert_call_log": {
    "name": "Expert Call Log",
    "purpose": "Check employer cooling-off rules and log compliance sign-offs before expert interviews."
  },
  "app_rm_kpi_ingest": {
    "name": "KPI Collector",
    "purpose": "Collect six monthly headline numbers—revenue, margin, backlog, headcount, cash, and debt."
  }
}
